import React, { Component } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Login from "component/Login/Login";
import Vales from "component/Vales/Vales";
import TableVales from "component/TableVales/TableVales";
import ValeClass from "component/ValeClass/ValeClass";
import MailEnviado from "component/MailEnviado/MailEnviado";
import ValeComponent from "component/ValeComponent/ValeComponent";
import BackofficeAysaLogeado from "component/BaclofficeAysaLogeado/BackofficeAysaLogeado";
import BackofficeVaciaderoLogeado from "component/BackofficeVaciaderoLogeado/BackofficeVaciaderoLogeado";
import ValeInfoContent from "component/ValeInfoContent/ValeInfoContent";
import ValeScanned from "component/ValeScanned/ValeScanned";
import Register from "component/Register/Register";
import NuevaContraseña from "component/NuevaContraseña/NuevaContraseña";
import RecuperarContraseña from "component/RecuperarContraseña/RecuperarContraseña";
//import TagManager from "react-gtm-module";
import Backoffice from "component/BackOffice/BackOffice";
import BackOfficeLogueado from "component/BackOfficeLogueado/BackOfficeLogueado";
import UrlNotFound from "component/UrlNotFound/UrlNotFound";

/* const tagManagerArgs = {
  dataLayer: {
    userId: "001",
    userProject: "project",
    page: "home",
  },
  dataLayerName: "Vales",
}; */

/* function Home() {
  TagManager.dataLayer(tagManagerArgs);

  return <Login />;
} */

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />

        <Route path="/vales" element={<Vales />} />

        <Route path="/register" element={<Register />} />

        <Route path="/ValeInfoContent" element={<ValeInfoContent />} />

        <Route path="/ValeScanned/" element={<ValeScanned />} />

        <Route path="/backoffice" element={<Backoffice />} />
        <Route path="/backofficeL" element={<BackOfficeLogueado />} />

        <Route
          path="/backoffice/reporte"
          element={<BackofficeAysaLogeado />}
        />

        <Route
          path="/backoffice/vaciadero"
          element={<BackofficeVaciaderoLogeado />}
        />

        <Route path="/table" element={<TableVales />} />
        <Route path="/vale" element={<ValeComponent />} />
        <Route path="/valeClass" element={<ValeClass />} />
        <Route path="/recuperar" element={<RecuperarContraseña />} />

        <Route path="/mailenviado" element={<MailEnviado />} />
        <Route path="/resetPassword/" element={<NuevaContraseña />} />

        <Route path="/backofficeVaciadero" element={<UrlNotFound />} />
        <Route path="/backofficeAysa" element={<UrlNotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
